import React, { useState } from 'react';
import {
    EuiModal,
    EuiModalHeader,
    EuiModalHeaderTitle,
    EuiModalBody,
    EuiOverlayMask,
} from '@elastic/eui';
import '@elastic/eui/dist/eui_theme_light.css';
import CourseAddForm from '../forms/CourseAddForm';
import '../styles/courseAddModal.css';

const CourseAddPage = ({ isModalVisible, setIsModalVisible }) => {
    if (!isModalVisible) {
        return null;
    }

    return (
        <EuiOverlayMask>
            <EuiModal
                onClose={() => setIsModalVisible(false)}
                className="course-add-modal"
            >
                <EuiModalHeader>
                    <EuiModalHeaderTitle>Add Course</EuiModalHeaderTitle>
                </EuiModalHeader>

                <EuiModalBody>
                    <CourseAddForm onSuccess={() => setIsModalVisible(false)} />
                </EuiModalBody>
            </EuiModal>
        </EuiOverlayMask>
    );
};

export default CourseAddPage;
